export class BannerParamValue {

    constructor(private _value: string) {}

    get value(): string {
        return this._value;
    }

}
